import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import TextField from './TextField';
import SearchIcon from '../icon/SearchIcon';
import InputAdornment from '@material-ui/core/InputAdornment';

class SearchWithButton extends Component {
    render() {
        const { placeholder, className, searchKeyword } = this.props;

        return (
            <div>
                <form onSubmit={this.onSearchSubmit}>
                    <TextField
                        placeholder={placeholder}
                        className={className}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment>
                                    <div className="input-adornment--end" onClick={this.onSearchSubmit}>
                                        <SearchIcon />
                                    </div>
                                </InputAdornment>
                            ),
                            inputProps: {
                                ref: this.onSearchFieldRef
                            }
                        }}
                        customvalue={searchKeyword}
                    />
                </form>
            </div>
        );
    }

    onSearchSubmit = e => {
        if (e) e.preventDefault();

        if (this.searchFieldInput) {
            let { onSearchSubmit } = this.props;
            if (onSearchSubmit) {
                onSearchSubmit(this.searchFieldInput.value);
            }
        }
    };

    onSearchFieldRef = input => {
        this.searchFieldInput = input;
    };
}

export default withStyles({})(SearchWithButton);
